import { render, staticRenderFns } from "./editScreen.vue?vue&type=template&id=e5d23dce&scoped=true&"
import script from "./editScreen.vue?vue&type=script&lang=js&"
export * from "./editScreen.vue?vue&type=script&lang=js&"
import style0 from "./editScreen.vue?vue&type=style&index=0&id=e5d23dce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d23dce",
  null
  
)

component.options.__file = "editScreen.vue"
export default component.exports